import { Quote } from './../../quotes/quote.model';
import { ClubsService } from './../../clubs/clubs.service';
import { Club } from './../../clubs/club.model';
import { CityService } from './../../../shared/services/cities.service';
import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { REGEX } from 'src/app/app.validators';
import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { City } from 'src/app/shared/models/city.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Member } from '../member.model';
import { MembersService } from '../members.service';
import { ApiConstants } from 'src/app/shared/services/api-constants.service';

@Component({
    selector: 'members-form',
    templateUrl: 'members-form.component.html'
})

export class MembersFormComponent extends BaseFormComponent<Member> {
 
    public cities: Array<City>;
    public clubs: Array<Club>;
    public documents: Array<any>;
    public club: Club;
    public quotas: Array<Quote>;

    public isThereCitiesInLocalStorage: boolean;
    isThereClubsInLocalStorage: boolean;
    
    constructor(
        public injector:Injector,
        public membersServ:MembersService,
        public constantServ:ApiConstants,
        public cityServ:CityService,
        public clubServ:ClubsService
    ) { 
        super(injector,'member','/admin/members',Member.fromJsonToObject,membersServ);
    }
   
    clubQuotas(id:number){
       this.club = this.clubs.find(element=>element.id==id)
    }

    protected initChildMethods(): void {

  this.loadConstants();

        // this.formSubscription.add(this.partnerServ.getAll().subscribe(partners => {
        //     this.partners=partners
        // }))


        !!localStorage.getItem('cities')?
        this.isThereCitiesInLocalStorage=true:
        this.isThereCitiesInLocalStorage=false

        if(this.isThereCitiesInLocalStorage){
            this.cities=this.cityServ.buildArrayOfObjects(JSON.parse(localStorage.getItem("cities")));
           
        }else{

            this.formSubscription.add(this.cityServ.getAll().subscribe(cities => {
                this.cities=cities
                this.saveInLocalStorage(cities,'cities')
            }))
        }


        !!localStorage.getItem('clubs')?
        this.isThereClubsInLocalStorage=true:
        this.isThereClubsInLocalStorage=false


        if(this.isThereClubsInLocalStorage){
            this.clubs=this.clubServ.buildArrayOfObjects(JSON.parse(localStorage.getItem("clubs")));
            this.clubQuotas(this.objectForm.value.clubs_id)
        }else{

            this.formSubscription.add(this.clubServ.getAll().subscribe(clubs => {
                this.clubs=clubs
                this.clubQuotas(this.objectForm.value.clubs_id)
                this.saveInLocalStorageClub(clubs,'clubs')
            }))
        }

    }
    loadConstants() {
        const doc=JSON.parse(localStorage.getItem("constants"));

        if(!!doc && doc.documents){
            this.documents=doc.documents;
        }else{
            this.formSubscription.add(this.constantServ.getAllDocuments().subscribe(documents => {
                this.documents=documents;
            }))
        }
    }
    
    private saveInLocalStorage(cities:Array<City>,objTypeName:string) {
        localStorage.setItem(objTypeName,JSON.stringify(cities))
    }
    private saveInLocalStorageClub(clubs:Array<Club>,objTypeName:string) {
        localStorage.setItem(objTypeName,JSON.stringify(clubs))
    }

    protected buildForm(): void {
        this.objectForm = this.formBuilder.group({
            name: this.formBuilder.control(null,[RxwebValidators.required()]),
            member_number: this.formBuilder.control(null,[RxwebValidators.required(),Validators.pattern(REGEX.numberPatternNoComma)]),
            address: this.formBuilder.control(null,[RxwebValidators.required()]),
            phone: this.formBuilder.control(null,[RxwebValidators.required(),Validators.minLength(9),Validators.maxLength(14),Validators.pattern(REGEX.numberPattern)]),
            email: this.formBuilder.control(null,[RxwebValidators.required(),,RxwebValidators.email()]),
            documents_id: this.formBuilder.control(null,[RxwebValidators.required()]),
            document_number: this.formBuilder.control(null,[RxwebValidators.required()]),
            member_type: this.formBuilder.control(null,[RxwebValidators.required()]),
            cities_id: this.formBuilder.control(null,[RxwebValidators.required()]),
            quotas_id: this.formBuilder.control(null,[RxwebValidators.required()]),
            clubs_id: this.formBuilder.control(null,[RxwebValidators.required()]),
            users_id: this.formBuilder.control(this.auth.user.id),
            id: this.formBuilder.control(null)
          })
    }

    protected initChildProprieties(): void {
        this.isThereCitiesInLocalStorage=false;
        this.isThereClubsInLocalStorage=false;
        this.club=new Club();
    }

}